document.addEventListener("DOMContentLoaded", () => {
  const isCartPage = window.location.href.includes("/cart");

  if (isCartPage) {
    const cartSliderNT = document.querySelector(
      ".drawer__footer #bss-b2b-net-term-button-wrapper"
    );
    if (cartSliderNT) {
      cartSliderNT.remove();
    }
  }

  const language = Shopify.locale;
  if (language === "en") {
    const intervalId = setInterval(() => {
      const thElements = document.querySelectorAll(
        ".quantity_break_table thead th"
      );

      if (thElements.length > 0) {
        clearInterval(intervalId);

        thElements.forEach((th) => {
          const text = th.innerText.trim();

          if (text === "Mengenbereich") {
            th.innerText = "Quantity range";
          } else if (text === "Rabatt") {
            th.innerText = "Discount";
          }
        });
      }
    }, 200);

    setTimeout(() => {
      clearInterval(intervalId);
    }, 5000);
  }
});

if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
  setTimeout(() => {
    const observer = new MutationObserver((MutationList) => {
      // console.log(MutationList);
      for (let item of MutationList) {
        if (item.target.classList.contains("totals__total-value") || item.target.id === 'cart-icon-bubble') {
          BSS_B2B.nt.initFunction();
          document.dispatchEvent(new Event("DOMContentLoaded"));
        }
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }, 300);
}
